var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contact" } }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.msgError || _vm.msgSuccess
          ? _c("div", { staticClass: "col-md-12 form-msg" }, [
              _vm.msgError
                ? _c("small", { staticClass: "error" }, [
                    _vm._v(_vm._s(_vm.msgError))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.msgSuccess
                ? _c("small", { staticClass: "success" }, [
                    _vm._v(_vm._s(_vm.msgSuccess))
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.loading
          ? _c("form", [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "form-row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.name,
                            expression: "name"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "nome",
                          name: "nome",
                          placeholder: "Nome"
                        },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.email,
                            expression: "email"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "email",
                          name: "email",
                          placeholder: "E-mail"
                        },
                        domProps: { value: _vm.email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.email = $event.target.value
                          }
                        }
                      })
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-12 form-group" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.message,
                      expression: "message"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { placeholder: "Mensagem" },
                  domProps: { value: _vm.message },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.message = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-12 form-group" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.submit()
                      }
                    }
                  },
                  [_vm._v("ENVIAR")]
                )
              ])
            ])
          : _c("div", { staticClass: "col-md-12" }, [
              _c("h5", [_vm._v("Aguarde, enviando...")])
            ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n          Entre em "),
        _c("span", [_vm._v("Contato")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Adoramos receber mensagens, críticas e sugestões! Abra seu coração e fale conosco."
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Nossa plataforma está sempre em evolução e com o seu apoio poderemos construir a melhor\n          ferramenta de transformação e impacto social."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ab8a995", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ab8a995","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/ContactSection.vue
// module id = null
// module chunks = 